import { useState } from "react";
import { Outlet } from "react-router-dom";
// @mui
import { styled } from "@mui/material/styles";
//

import NavSection from "./NavSection";
import { Icon } from "@mui/material";

const APP_BAR_MOBILE = 80;
const APP_BAR_DESKTOP = 60;

const StyledRoot = styled("div")({
  display: "flex",
  minHeight: "100%",
  overflow: "hidden",
});

const Main = styled("div")(({ theme }) => ({
  flexGrow: 1,
  overflow: "auto",
  minHeight: "100%",
  paddingTop: APP_BAR_MOBILE,
  paddingLeft: 10,
  paddingBottom: theme.spacing(10),
  [theme.breakpoints.up("lg")]: {
    paddingTop: APP_BAR_DESKTOP + 14,
    paddingLeft: theme.spacing(3),
    paddingRight: theme.spacing(2),
  },
}));

// ----------------------------------------------------------------------
// const configsButton = (
// <MDBox
//   display="flex"
//   justifyContent="center"
//   alignItems="center"
//   width="3.25rem"
//   height="3.25rem"
//   bgColor="white"
//   shadow="sm"
//   borderRadius="50%"
//   position="fixed"
//   right="2rem"
//   bottom="2rem"
//   zIndex={99}
//   color="dark"
//   sx={{ cursor: "pointer" }}
//   // onClick={handleConfiguratorOpen}
// >
//   <Icon fontSize="small" color="inherit">
//     settings
//   </Icon>
// </MDBox>
// <Icon fontSize="small" color="inherit">
//   settings
// </Icon>
// );
export default function AdminDashboardLayout() {
  return (
    <StyledRoot>
      <NavSection />

      <Main>
        <Outlet />
        {/* {configsButton} */}
      </Main>
    </StyledRoot>
  );
}
